import { render, staticRenderFns } from "./MediacontactProductTypeCreate.vue?vue&type=template&id=6a031551"
import script from "./MediacontactProductTypeCreate.vue?vue&type=script&lang=js"
export * from "./MediacontactProductTypeCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports